import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {ReduxStateInt, setBaseUrl} from "../Reducer/GlobalReducer";

export default function Switcher()
{
    const baseUrl = useSelector((state: ReduxStateInt) => {
        return state.baseUrl
    })
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const url = "https://90.189.218.200:5001"

    dispatch(setBaseUrl(url))
    setTimeout(()=>navigate('/'),2000)


    return null
}